module.exports = __webpack_public_path__ + "img/mysterious sword master.27b282a6.png";